import CartService from '../services/CartService';

export const removeUnavailableItemsFromCart = (variants: any, currency: GQL.ICurrency) => {

  const unavailableIds = variants.fullVariants.variants
    .filter((variant: any) => {
      const canBeSold = variant && variant.product
        && variant.product.availability
        && variant.product.availability.allowedActions
        && variant.product.availability.allowedActions[currency.value]
        && variant.product.availability.allowedActions[currency.value].sell;

      return !canBeSold;
    })
    .map((variant: any) => variant.id);
  unavailableIds.forEach((id: any) => CartService.GetInstance().removeItemCompletelyFromCart(id));
};



// WEBPACK FOOTER //
// ./src/helpers/removeUnavailableItemsFromCart.ts